import { padLeft } from "./pad-left";

export function timeFormat(date: Date) {
  const hour = date.getHours();
  const minute = date.getMinutes();
  return `${hour}:${padLeft(minute, 2)}`;
}
